import axios from "axios";
import httpTools from './httpTools';
import Q from "q";

const featureFlags = (() => {
  let featureFlagsUrl = httpTools.getFeatureFlagsUrl();
  return {
    get: () => {
      let defer = Q.defer();
      axios
        .get(`${featureFlagsUrl}`)
        .then(res => {
          defer.resolve(res.data);
        })
        .catch(error => {
          //console.error(error);
          defer.reject(error);
        });
      return defer.promise;
    }
  };
})();
export default featureFlags;



// WEBPACK FOOTER //
// ./src/services/http/featureFlags.js